<template>
  <article class="dish-card">
    <button v-if="photo && !imageFailed" type="button" class="dish-photo" :aria-label="'Ampliar foto de ' + dish.name" @click="expanded = true">
      <img :src="photo" :alt="dish.name" loading="lazy" decoding="async" width="640" height="480" @error="imageFailed = true" />
    </button>
    <div class="dish-details">
      <div class="dish-heading"><h3>{{ dish.name }}</h3><span v-if="showPrice && dish.price !== undefined" class="dish-price notranslate">{{ price }} €</span></div>
      <p v-if="dish.descripcion || dish.description" class="dish-description">{{ dish.descripcion || dish.description }}</p>
      <div v-if="dishAllergens.length" class="dish-allergens" aria-label="Alérgenos del plato">
        <img v-for="allergen in dishAllergens" :key="allergen.key" :src="allergen.url" :alt="allergen.name" :title="allergen.name" loading="lazy" width="24" height="24" />
      </div>
    </div>
    <el-dialog :title="dish.name" :visible.sync="expanded" :show-close="false" width="92%" custom-class="customer-dialog" append-to-body>
      <img v-if="expanded" :src="photo" :alt="dish.name" class="full-photo" />
      <div slot="footer"><el-button class="customer-dialog-close" @click="expanded = false">Cerrar</el-button></div>
    </el-dialog>
  </article>
</template>
<script>
import {productPrice} from '../pricing';
import { imageUrl } from "../api/request";
export default {
  props: { dish: { type: Object, required: true }, allergens: { type: Array, default: () => [] }, showPrice: { type: Boolean, default: true } },
  data() { return { expanded: false, imageFailed: false }; },
  computed: {
    photo() { return imageUrl(this.dish.image); },
    price() { const price = Number(productPrice(this.dish)); return Number.isFinite(price) ? price.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : productPrice(this.dish); },
    dishAllergens() { return (this.dish.alergenos || []).map(key => this.allergens.find(item => item.key === key)).filter(Boolean); }
  },
  watch: { photo() { this.imageFailed = false; } }
};
</script>
<style scoped>
.dish-card { display: flex; align-items: stretch; min-width: 0; border: 1px solid #e0e6e4; border-radius: 12px; background: #fff; overflow: hidden; }
.dish-photo { display: block; flex: 0 0 180px; align-self:center; padding: 0; position: relative; width: 180px; height:135px; min-height: 135px; border: 0; cursor: zoom-in; background: #edf1f0; }
.dish-photo img { position:absolute;inset:0;display: block; width: 100%; height: 100%; object-fit: cover; }
.dish-details { flex: 1; min-width: 0; padding: 20px; }
.dish-heading { display: flex; align-items: baseline; justify-content: space-between; gap: 14px; }
.dish-heading h3 { margin: 0; font-size: 17px; font-weight: 700; line-height: 1.45; overflow-wrap: anywhere; }
.dish-price { flex-shrink: 0; font-size: 16px; font-weight: 700; color: var(--brand); }
.dish-description { margin: 8px 0 0; color: #687780; font-size: 14px; line-height: 1.6; overflow-wrap: anywhere; }
.dish-allergens { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.dish-allergens img { object-fit: contain; }
.full-photo { display: block; max-width: 100%; max-height: 70vh; max-height: 70dvh; object-fit: contain; margin: 0 auto; }
@media(max-width:600px) { .dish-photo { flex-basis: 100px; width: 100px; height: auto; min-height: 100px; align-self: stretch; } .dish-details { padding: 14px; } .dish-heading { flex-wrap: nowrap; align-items: flex-start; gap: 10px; } .dish-heading h3 { flex: 1; min-width: 0; } .dish-price { white-space: nowrap; line-height: 1.45; } .dish-heading h3 { font-size: 16px; } .dish-price { font-size: 15px; } }
</style>

